module.exports = __webpack_public_path__ + "media/assets/images/flags/zw-885397bd449724d7ffe8d4d4c7fb496d.svg";